import React from 'react';
import { Spinner } from 'react-bootstrap';
import './LoadingSpinner.css';

const LoadingSpinner = ({ 
  message = "Carregando...", 
  size = "md", 
  variant = "primary",
  overlay = false,
  center = true,
  className = ""
}) => {
  const getSpinnerSize = () => {
    switch (size) {
      case "sm": return { width: '1.5rem', height: '1.5rem' };
      case "lg": return { width: '3rem', height: '3rem' };
      case "xl": return { width: '4rem', height: '4rem' };
      default: return { width: '2rem', height: '2rem' };
    }
  };

  const content = (
    <div className={`loading-spinner-content ${className}`}>
      <Spinner 
        animation="border" 
        variant={variant}
        style={getSpinnerSize()}
        className="loading-spinner-icon"
      />
      {message && (
        <div className="loading-spinner-message">
          {message}
        </div>
      )}
    </div>
  );

  if (overlay) {
    return (
      <div className="loading-spinner-overlay">
        <div className="loading-spinner-backdrop">
          {content}
        </div>
      </div>
    );
  }

  if (center) {
    return (
      <div className="loading-spinner-center">
        {content}
      </div>
    );
  }

  return content;
};

export default LoadingSpinner;